import * as angular from "angular";

//@ts-check

class NavigationService {
    constructor(
        $http,
        $window,
        $timeout,
        $location,
        $interval,
        $rootScope,
        CommonService,
        RegisterService,
        BuildingsService,
        LocalStorageService,
        AuthenticationService,
        NotificationService,
        $state
    ) {
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$interval = $interval;
        this.$rootScope = $rootScope;
        this.CommonService = CommonService;
        this.RegisterService = RegisterService;
        this.BuildingsService = BuildingsService;
        this.LocalStorageService = LocalStorageService;
        this.AuthenticationService = AuthenticationService;
        this.NotificationService = NotificationService;
        this.$state = $state;

        this.isBusySettingLocalUserObjects = false;
        this.hasLocalUserObjectsBeenSet = false;

        this.isBusyActivating = false;
        this.hasActivated = false;


        this.init();
    }

    init() {
        this.again;
        this.navigationData = {
            selectedTab: undefined,
            selectedBuildingRef: undefined,
            navigated: undefined
        };
        this.InitialiseNavigation();
    }

    async activate() {

    }

    async InitialiseNavigation() {

        if (this.isBusyActivating || this.hasActivated) {
            return;
        }

        this.isBusyActivating = true;
        await this.logoutUser();
        await this.setLocalUserObjects();
        this.confirmEmail();
        this.schemeLogin();
        this.getClearanceInfo();
        this.getRentalsInfo();
        this.getAuditsInfo();
        this.getAuditorsInfo();
        this.getResetPasswordInfo();
        this.unsubscribeToMonthlyFinancialDoc();
        await this.selectedBuilding();
        this.isBusyActivating = false;
        this.hasActivated = true;

        await this.checkValidProfile();

        this.gotoTab();

        this.$rootScope.$on('$stateChangeStart',
            function (event, toState, toParams, fromState, fromParams) {
                if (!this.hasActivated) {
                    event.preventDefault();
                }
            })
    }

    async checkValidProfile() {
        let currentUser = this.AuthenticationService.currentUser();

        if (!!currentUser) {

            let profileIsNotValid = false
            if (!currentUser.BuildingProfiles) {
                profileIsNotValid = true;
            }
            else {
                let allClaims = [...currentUser.BuildingProfiles].flatMap(x => x.BuildingClaimMapped);
                if ([...allClaims].length == 0) {
                    profileIsNotValid = true;
                }
            }

            if (profileIsNotValid) {
                this.AuthenticationService.logout();
                alert('No profile could be established - Please contact our offices');
            }

        }
    }

    async redirectedFrom() {
        const redirectedFrom = this.CommonService.QueryString('redirectedFrom');
        if (redirectedFrom == 'register-complete') {
            this.$rootScope.$broadcast('show-login-auth-modal');
            this.CommonService.DeleteQueryStringParameter('redirectedFrom');
        }
    }

    async setLocalUserObjects() {

        const confirmToken = this.CommonService.QueryString('confirmToken');
        if (confirmToken) {
            this.confirmEmail();
            return;
        }

        if (this.isBusySettingLocalUserObjects || this.hasLocalUserObjectsBeenSet) {
            return;
        }

        this.isBusySettingLocalUserObjects = true;
        this.$rootScope.$broadcast('change-is-busy', true);

        await this.impersonateUser();
        await this.getTokenAndAuthUser();
        await this.selectedBuilding();

        this.isBusySettingLocalUserObjects = false;
        this.$rootScope.$broadcast('change-is-busy', false);

        this.hasLocalUserObjectsBeenSet = true;
    }

    getResetPasswordInfo() {
        const resetToken = this.CommonService.QueryString('ResetToken');
        if (resetToken) {
            if (this.again) return;

            this.again = this.$interval(() => {
                let retries = this.$timeout(() => {
                    this.AuthenticationService
                        .promptForNewPassword(resetToken)
                        .then(
                            (results) => {
                                const isDone = this.LocalStorageService.retrieve('resetPasswordToken');
                                if (isDone) {
                                    this.$interval.cancel(this.again);
                                    this.$timeout.cancel(retries);
                                }
                            },
                            (err) => {
                                console.error("Couldn't prompt the user for a new password.");
                            }
                        )
                        .finally(() => {
                            retries = undefined;
                        }, this.CommonService.apiRetry.value / 2);
                });
            }, this.CommonService.apiRetry.value / 2);
        }
    }

    gotoTab(tabToShow) {
        const selectedTab = this.CommonService.QueryString('Tab');

        if (selectedTab) {
            const date = this.CommonService.QueryString('date');
            this.navigationData.selectedTab = selectedTab;
            this.$rootScope.$broadcast('navigation-onload-changed', { selectedTab, date });
        }

        this.gotoTop();
    }

    confirmEmail() {
        const confirmEmail = this.CommonService.QueryString('confirmEmail');
        const confirmToken = this.CommonService.QueryString('confirmToken');
        if (confirmEmail || confirmToken) {
            this.LocalStorageService.clear("FullSite");
            this.$rootScope.$broadcast('accounts-confirm-email', { confirmEmail, confirmToken });
        }
    }

    async selectedBuilding() {
        const queryStringBuildingRef = this.CommonService.QueryString('DBRef')
            ? this.CommonService.QueryString('DBRef').toUpperCase()
            : undefined;

        if (!queryStringBuildingRef) {
            return;
        }

        let oldSelectedBuildingRef = this.navigationData.selectedBuildingRef;
        if (typeof oldSelectedBuildingRef === 'object')
            oldSelectedBuildingRef = oldSelectedBuildingRef.SchemeReference.toUpperCase();

        if (queryStringBuildingRef !== oldSelectedBuildingRef) {
            await this.LocalStorageService.save('selectedBuildingRef', queryStringBuildingRef);
            this.navigationData.selectedBuildingRef = queryStringBuildingRef;
            this.$rootScope.$broadcast('building-reference-changed', queryStringBuildingRef);
        }

        if (!!queryStringBuildingRef) {
            await this.CommonService.DeleteQueryStringParameter('DBRef')
        }
    }

    async impersonateUser() {
        const userName = this.CommonService.QueryString('impersonateUser');
        const impersonationToken = this.CommonService.QueryString('impersonationToken');

        if (!userName && !impersonationToken) return;

        if (userName && impersonationToken) {
            this.LocalStorageService.clear("FullSite");
            this.AuthenticationService.impersonateUser(userName, impersonationToken);
        }
        else {
            this.NotificationService.error('Invalid Login Token');
        }
    }

    schemeLogin() {
        const schemeReference = this.CommonService.QueryString('schemeLogin');
        const schemeToken = this.CommonService.QueryString('schemeToken');

        if (!schemeReference && !schemeToken) return;

        if (schemeReference && schemeToken) {
            this.LocalStorageService.clear("FullSite");
            this.AuthenticationService.schemeLogin(schemeReference, schemeToken);
        }
        else {
            this.NotificationService.error('Invalid Login Token');
        }
    }

    navigate() {
        this.navigationData.navigated = true;
    }

    async logoutUser() {
        const url = this.$location.absUrl().toLowerCase();
        const shouldLogOut = url.indexOf('resetuser') > -1;

        if (shouldLogOut) this.AuthenticationService.logout();
    }

    async getTokenAndAuthUser() {
        const token = this.CommonService.QueryString('authtoken');
        const oldSession = this.LocalStorageService.retrieve('userSession');

        if (token) {
            if (oldSession && oldSession.AuthToken &&
                oldSession.AuthToken.toLowerCase() === token.toLowerCase()) {
                return;
            }

            this.LocalStorageService.clear("FullSite");

            if (this.isInvalidOldToken /* && oldSession.length > 0*/) {
                if (oldSession.AuthToken.toLowerCase() === token.toLowerCase()) {
                    this.LocalStorageService.save('lastLoggedIn', lastLogin);
                }
            }
            this.NotificationService.success('LOGGING YOU IN');
            this.LocalStorageService.clear();
            await this.AuthenticationService.authorize();
            await this.BuildingsService.init();
            await this.CommonService.DeleteQueryStringParameter('authtoken');
        }
    }

    getClearanceInfo() {
        const clearanceToken = this.CommonService.QueryString('clearancetoken');
        if (clearanceToken) {
            this.LocalStorageService.clear("Clearances");
            this.AuthenticationService.authorizeClearanceToken(clearanceToken).then(
                (results) => {
                    if (results.Data && (results.Data.hasOwnProperty('CorrelationId') && results.Data.CorrelationId)) {
                        const clearanceCorrelationId = results.Data.CorrelationId;
                        this.LocalStorageService.save('clearanceCorrelationId', clearanceCorrelationId);
                        this.$rootScope.$broadcast('clearance-user-logged-in', clearanceCorrelationId);
                    }
                },
                (err) => {
                    console.error(err);
                }
            );
        }
    }

    getRentalsInfo() {
        const rentalsToken = this.CommonService.QueryString('rentalstoken');
        if (rentalsToken) {
            this.LocalStorageService.clear("Rentals");
            this.AuthenticationService.authorizeRentalsToken(rentalsToken).then(
                (results) => {
                    if (results.Data && (results.Data.hasOwnProperty('CorrelationId') && results.Data.CorrelationId)) {
                        const rentalsCorrelationId = results.Data.CorrelationId;
                        this.LocalStorageService.save('rentalsCorrelationId', rentalsCorrelationId);
                        this.$rootScope.$broadcast('rentals-user-logged-in', rentalsCorrelationId);
                    }
                },
                (err) => {
                    console.error(err);
                }
            );
        }
    }

    getAuditsInfo() {
        var auditsToken = this.CommonService.QueryString('auditsToken');
        if (!auditsToken) { 
            auditsToken = this.LocalStorageService.retrieve("auditsToken");
        }
        if (auditsToken) {
            this.LocalStorageService.clear("Audits");
            this.AuthenticationService.authorizeAuditsToken(auditsToken).then(
                (results) => {
                    if (results.Data && (results.Data.hasOwnProperty('CorrelationId') && results.Data.CorrelationId)) {
                        const auditsCorrelationId = results.Data.CorrelationId;
                        this.LocalStorageService.save('auditsCorrelationId', auditsCorrelationId);
                        this.LocalStorageService.save('auditsToken', auditsToken);
                        this.$rootScope.$broadcast('audits-user-logged-in', auditsCorrelationId);
                    }
                },
                (err) => {
                    console.error(err);
                }
            );
        }
    }

    getAuditorsInfo() {
        var auditorToken = this.CommonService.QueryString('auditorToken');
        if (!auditorToken) {
            auditorToken = this.LocalStorageService.retrieve("auditorToken");
        }
        if (auditorToken) {
            this.LocalStorageService.clear("Auditor");
            this.AuthenticationService.authorizeAuditsToken(auditorToken).then(
                (results) => {
                    if (results.Data && (results.Data.hasOwnProperty('CorrelationId') && results.Data.CorrelationId)) {
                        const auditorsCorrelationId = results.Data.CorrelationId;
                        this.LocalStorageService.save('auditorsCorrelationId', auditorsCorrelationId);
                        this.LocalStorageService.save('auditorToken', auditorToken);
                        this.$rootScope.$broadcast('auditors-user-logged-in', auditorsCorrelationId);
                    }
                },
                (err) => {
                    console.error(err);
                }
            );
        }
    }

    unsubscribeToMonthlyFinancialDoc() {
        const shouldUnsubscribeToMonthlyFinancialDocs = this.CommonService.QueryString('unsubscribe');
        if (shouldUnsubscribeToMonthlyFinancialDocs) {
            this.$timeout(() => {
                this.$rootScope.$broadcast('unsubscribe-monthly-financial-docs');
            }, 800);
        }
    }

    gotoTop(speed) {
        $('html, body').animate({ scrollTop: 0 }, speed || 'fast', 'swing');
    }
}

export default /* @ngInject */ (
    $http,
    $window,
    $timeout,
    $location,
    $interval,
    $rootScope,
    CommonService,
    RegisterService,
    BuildingsService,
    LocalStorageService,
    AuthenticationService,
    NotificationService,
    $state
) =>
    new NavigationService(
        $http,
        $window,
        $timeout,
        $location,
        $interval,
        $rootScope,
        CommonService,
        RegisterService,
        BuildingsService,
        LocalStorageService,
        AuthenticationService,
        NotificationService,
        $state
    );
